import Vue from 'vue'
import Router from 'vue-router'
//【cognito】
import cognito from './cognito'               
import store from './store'
import { initMenu } from "./utils/menus"
//import Login from './views/Login.vue'
import Signin from './views/Signin.vue'
import ResetPass from './views/ResetPass.vue'
import Home from './views/Home.vue'
import UserLogout from './views/user/UserLogout.vue'

Vue.use(Router)

// 例外対応
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [
    //{
    //    path: '/login',
    //    name: 'Login',
    //    component: Login,
    //    hidden: true
    //},
    {
        path: '/',
        name: 'Signin',
        component: Signin,
        hidden: true,
        //【cognito】
        meta: { notRequiredAuth: true }      
    },
     {
         path: '/resetPass:title',
         name: 'ResetPass',
         component: ResetPass,
         //【cognito】
         meta: { notRequiredAuth: true }
     },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        hidden: true,
        //【cognito】
        meta: { requiredAuth: true }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: UserLogout,
        hidden: true,
        //【cognito】
        meta: { notRequiredAuth: true }
    }
];


const router = new Router({
    routes,
});

//認証情報の有無によるルート制御
router.beforeEach(async (to, from, next) => {


    //【cognito】
    cognito.isAuthenticated()
        .then(session => { 
            initMenu(router, store);
            if (to.matched.some(record => record.meta.notRequiredAuth)) {
                console.log(session)
                next({
                    path: '/home',
                })
            }
        })
        .catch(error => { 
            if (to.matched.some(record => record.meta.requiredAuth)) {
                console.log(error)
                next({
                    path: '/',
                    query: { redirect: to.fullPath }
                })
            }
        })
    next()

    //認証なし
    //if (to.path == '/') {
    //    next();
    //} else {
    //    initMenu(router, store);
    //    next();
    //}

})

export default router;
